module.exports = __webpack_public_path__ + "static/media/arrow.8bad8773.svg";